// extracted by mini-css-extract-plugin
module.exports = {"wrap":"TargetViewIntro_wrap__kgpGq","txt_wrap":"TargetViewIntro_txt_wrap__35P6_","img_wrap":"TargetViewIntro_img_wrap__3WYSI","box":"TargetViewIntro_box__skA9E"};